import React from "react";

const MobileNav = (props) => {
  const { isNavOpen } = props;

  return (<section className="m-nav show-xl">
    <div className={`accor-wrap ${isNavOpen ? 'open' : ''}`}>
      <ul className="menu">
          <a href="https://unbxd.com/" target="_blank" className="btn login-btn">Visit unbxd.com</a>
          <a href="https://unbxd.com/demo/" target="_blank" className="btn btn-primary btn-md">Request a demo</a>
      </ul>
    </div>
  </section>);
};

export default MobileNav;
